module.exports = __webpack_public_path__ + "content/954b134fed230e1055d567c0fd98e90d.png";